<div class="loader-sm-container" [ngClass]="loaderPosition">
    <div [ngClass]="loaderSize" [style.border-top-color]="loaderColor"></div>
    <span *ngIf="showText" id="loading-text">{{loaderText}}</span>
</div>